import { PegasusPangareClient } from '@/helpers/pegasusPangareClient';

export interface PracticeExam {
  id: number;
  name: string;
  description?: string;
  dexUrl?: string;
  startMomentIsoString: string;
  slug: string;
}

export interface UpsertPracticeExamCalendarEventsInput {
  practiceExam: PracticeExam;
  dexExamGroups?: string[];
}

export interface DeletePracticeExamCalendarEventsInput {
  practiceExamId: number;
  practiceExamStartDate: string;
  dexExamGroups?: string[];
}

export default class UEEPegasusPangareRequestService {
  static async upsertPracticeExamCalendarEvents(
    input: UpsertPracticeExamCalendarEventsInput,
  ) {
    return await PegasusPangareClient.request({
      method: 'PATCH',
      requestURL: `/freemium-study-planning/admin/calendar/practice-exam`,
      bodyData: input,
    });
  }

  static async deletePracticeExamCalendarEvents(
    input: DeletePracticeExamCalendarEventsInput,
  ) {
    return await PegasusPangareClient.request({
      method: 'POST',
      requestURL: `/freemium-study-planning/admin/calendar/delete-practice-exam`,
      bodyData: input,
    });
  }

  static async searchDexQuestions(
    searchTerm: string,
    limit: number,
    offset: number,
  ) {
    return await PegasusPangareClient.request({
      method: 'GET',
      requestURL: `/dex/admin/questions/search?searchTerm=${encodeURIComponent(
        searchTerm,
      )}&limit=${limit}&offset=${offset}`,
    });
  }
}
